import type { ActionReturn } from "svelte/action";

export function handleInvalidInputs(form: HTMLFormElement): ActionReturn {
	// Use capturing phase to catch all invalid events before they show browser bubbles
	function onInvalid(event: Event): void {
		event.preventDefault();
	}

	// Capture phase ensures we catch the event before any bubbling
	form.addEventListener("invalid", onInvalid, true);

	return {
		destroy(): void {
			form.removeEventListener("invalid", onInvalid, true);
		},
	};
}
